import React, { useContext } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { SkycityContext } from '../../lib/SkycityProvider'

import { error } from '@react/react-spectrum/Toast'
import Button from '@react/react-spectrum/Button'

import axios from 'axios'
import { ssApiSyncCall } from '../../lib/ccApi.js'

import {
    getFilename,
    getFilenameWithoutExt,
    getEncodedURI,
    getTempDirectory,
    getSenseiHeaders,
    checkFileType
} from '../../lib/skycity.js'

import {
    exploreIndexDocument,
    exploreHomeDirectory,
    uploadFile,
    retrieveRendition,
    retrievePreSignedDownloadUrl
} from '../../lib/acpApi.js'
const LinkHeader = require('http-link-header')

const uuid = require('uuid/v4')

export default function Operation (files) {
    const {
        inputFiles,
        inputSecondFiles,
        errorOptions,
        dispatch
    } = useContext(SkycityContext)

    async function start (curFile, curSecondFile) {
        // replace with presignedUrl
        const codePayload = {
            contentAnalyzerRequests: {
                'sensei:name': 'Body Parser via SkyCity',
                'sensei:invocation_mode': 'synchronous',
                'sensei:invocation_batch': false,
                'sensei:in_response': false,
                'sensei:engines': [
                    {
                        'sensei:execution_info': {
                            'sensei:engine': 'Feature:autocrop:Service-df8ce554d6554c18a341de2c4b8c2fbe'
                        },
                        'sensei:inputs': {
                            image: {
                                'dc:format': checkFileType(curFile.type),
                                'sensei:repoType': 'HTTP',
                                'repo:path': curFile.path
                            },
                            mask: {
                                'dc:format': checkFileType(curSecondFile.type),
                                'sensei:repoType': 'HTTP',
                                'repo:path': curSecondFile.path
                            }
                        },
                        'sensei:outputs': {
                            masks: {
                                'dc:format': 'image/png',
                                'sensei:multipart_field_name': 'masks'
                            },
                            objects: {
                                'dc:format': 'application/json',
                                'sensei:multipart_field_name': 'objects'
                            },
                            metadata: {
                                'dc:format': 'application/json',
                                'sensei:multipart_field_name': 'metadata'
                            }
                        }
                    }
                ]
            }
        }

        const formData = new FormData()
        formData.append('contentAnalyzerRequests', JSON.stringify(codePayload.contentAnalyzerRequests))

        const config = {
            file: curFile,
            url: `${process.env.REACT_APP_CONFIG_ENDPOINT_MLSENSEI}/predict`,
            method: 'POST',
            mode: 'cors',
            timeout: 90000,
            headers: getSenseiHeaders(),
            payload: codePayload,
            body: {
                formData: formData
            }
        }

        /* *********************************** */
        dispatch({ type: 'set-codes', payload: { config: config } })

        try {
            const responseBody = await ssApiSyncCall(config)
            const contentAnalyzerResponse = responseBody.get('contentAnalyzerResponse')
            // const response = JSON.parse(responseBody.get('metadata'))
            const senseiMetadata = JSON.parse(contentAnalyzerResponse)
            const masks = senseiMetadata.statuses[0].invocations[0]['sensei:outputs'].masks
            // const objects = senseiMetadata.statuses[0].invocations[0]['sensei:outputs'].objects

            const objectsOutput = JSON.parse(responseBody.get('objects'))
            // 1. Explore the Index Document and get the Primary URL of the home Directory
            const homeDirectoryPrimaryUrl = await exploreIndexDocument()

            // 2. Explore the home Directory and get the Create URL of the Cloud Documents Directory
            const exploreHomeDirectoryResponse = await exploreHomeDirectory(
                homeDirectoryPrimaryUrl
            )
            const cloudDocumentsCreateUrl = exploreHomeDirectoryResponse.createLink
            // upload masks
            for (let i = 0; i < masks.length; ++i) {
                const output = responseBody.get(masks[i]['sensei:multipart_field_name'])
                const blob = output.slice(0, output.size, 'image/png')
                const outputFileName = `bodyparser_mask_${i}_${uuid()}_${curFile.shortName}.png`
                const newFile = new File([blob], outputFileName, { type: 'image/png' })
                const outputHref = `${getTempDirectory()}/${outputFileName}`
                const fileUploaded = await uploadFile(
                    cloudDocumentsCreateUrl,
                    newFile
                )
                const uploadlinks = LinkHeader.parse(fileUploaded.headers.get('link'))
                const renditionUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/rendition'))[0].uri
                const primaryUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/primary'))[0].uri
                const preSignedDownloadUrl = await retrievePreSignedDownloadUrl(primaryUrl)
                const largeRendition = await retrieveRendition(
                    renditionUrl,
                    0,
                    'image/jpeg'
                )
                files.push({
                    inputFile: curFile,
                    name: getFilename(outputHref),
                    shortName: getFilenameWithoutExt(outputHref),
                    path: outputHref,
                    outputThumbnail: largeRendition,
                    output: largeRendition,
                    outputToDownload: preSignedDownloadUrl
                })
            }

            dispatch({
                type: 'skycity-success',
                payload: {
                    files: files,
                    response: objectsOutput,
                    loading: false,
                    wait: false
                }
            })
        } catch (e) {
            error(`${__('error_msg_title')}: ${e}`, {
                timeout: 0
            })
            errorOccured(`${__('error_msg_title')}: ${e}`)
        }
    }

    function run (e) {
        try {
            dispatch({ type: 'skycity-run', payload: {} })

            files = []
            const funcArray = []
            inputFiles.forEach(inputFile => {
                inputSecondFiles.forEach(inputSecondFile => {
                    funcArray.push(start(inputFile, inputSecondFile))
                })
            })

            axios.all(funcArray)
                .then((res) => {
                    // then
                })
                .catch((err) => {
                    console.log(`err: ${err}`)
                    const errMsg = `ERROR: ${JSON.stringify(err)}`
                    errorOccured(errMsg)
                })
                .finally(() => {
                    console.log('finally...')
                    dispatch({
                        type: 'sensei-end-wait'
                    })
                })
        } catch (e) {
            error(`${__('error_msg_title')}: ${e}`, {
                timeout: 0
            })
            errorOccured(`${__('error_msg_title')}: ${e}`)
        }
    }

    function isRunDisabled () {
        if (inputFiles && inputFiles.length > 0) {
            return false
        }
        return true
    }

    function errorOccured (errMsg, res) {
        error(errMsg.slice(0, errorOptions.wordSlice), {
            onClose: () => console.log('close'),
            timeout: errorOptions.msgTimeout
        })
        dispatch({ type: 'error-occured', payload: { errMsg: errMsg, response: res, loading: false, wait: false } })
    }

    try {
        return <div>
            <div className="adobe-skycity-button-right">
                <Button variant="cta" onClick={e => run(e)} disabled={isRunDisabled()}>{__('btn_run')}</Button>
            </div>
        </div>
    } catch (e) {
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }
}
